import React, { lazy } from 'react';

import MetaTags from '#/components/layout/header/MetaTags';
import WalletDashboardContent from '#/components/wallet/dashboard/WalletDashboardContent';
import { useSelector } from '#/reduxState/storeCore';

const VaultWithdrawalQueueTable = lazy(
  () => import('#/components/vaults/components/VaultWithdrawalQueueTable')
);

export default function VaultManagerWithdrawalQueueWalletPage() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  // if (mobileDetailEvent) {
  //   return (
  //     <BalanceHistoryDetailMobile
  //       onClose={() => setMobileDetailId(null)}
  //       transaction={mobileDetailEvent}
  //       activeChain={activeChain}
  //     />
  //   );
  // }

  return (
    <>
      <MetaTags title="Vault Withdrawal Queue" />

      <WalletDashboardContent
        title="Vault Withdrawal Queue"
        showBalanceActions
        // headerContentRight={
        //   <div style={{ display: 'flex', alignItems: 'center' }}>
        //     <DownloadBalanceHistoryCSV disabled={controlsDisabled} />
        //   </div>
        // }
      >
        <VaultWithdrawalQueueTable managerWallet={walletAddress} />
      </WalletDashboardContent>
    </>
  );
}
